import { render, staticRenderFns } from "./LargeBackground.vue?vue&type=template&id=5c1a29aa&scoped=true"
import script from "./LargeBackground.vue?vue&type=script&lang=ts"
export * from "./LargeBackground.vue?vue&type=script&lang=ts"
import style0 from "./LargeBackground.vue?vue&type=style&index=0&id=5c1a29aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1a29aa",
  null
  
)

export default component.exports